import { Buffer } from "buffer";

export const utf8ToHex = (str: string) => `0x${Buffer.from(str, 'utf8').toString('hex')}`;

export const stripHexPrefix = (str: string) => str.replace(/^0x/, '');

export const bufferToHex = (
  buf: Uint8Array,
  nozerox = false
): string =>
  nozerox
    ? Buffer.from(buf).toString('hex')
    : `0x${Buffer.from(buf).toString('hex')}`;

export const hexToBuffer = (hex: string): Buffer =>
  Buffer.from(
    stripHexPrefix(hex).length % 2 === 1
      ? `0${stripHexPrefix(hex)}`
      : stripHexPrefix(hex),
    'hex'
  );

export function promiseWithTimeout<T>(
  promise: Promise<T>,
  message = `Promise timed out`,
  ms: number = 5000
): Promise<T> {
  // create a promise that rejects in milliseconds
  const timeout = new Promise<never>((_, reject) => {
    setTimeout(() => {
      reject(new Error(message));
    }, ms);
  });

  // returns a race between timeout and the passed promise
  return Promise.race<T>([promise, timeout]);
}

// @TODO: 抽象成从外部传入
export const __IS_DEV__ = process.env.REACT_APP_ENV !== 'production';
